import useTrans from '../../../../../hooks/ui/useTrans';
import OverlayHeaderButton from '../../../../components/OverlayHeaderButton/OverlayHeaderButton';

import couponIcon from './graphics/coupon.svg?raw';
import couponAppliedIcon from './graphics/couponApplied.svg?raw';

type CouponOverlayHeaderButtonProps = {
    hasCouponApplied: boolean;
    onClick?: () => void;
};

const CouponOverlayHeaderButton = ({
    hasCouponApplied,
    onClick,
}: CouponOverlayHeaderButtonProps) => {
    const trans = useTrans('CustomerArea.Shared.OverlayHeader.');

    return (
        <OverlayHeaderButton
            icon={hasCouponApplied ? couponAppliedIcon : couponIcon}
            onClick={onClick}
        >
            {trans('CouponButton')}
        </OverlayHeaderButton>
    );
};

export default CouponOverlayHeaderButton;
